export const start = () => ({})

export const paymentMethodStyles = theme => ({
  dialogTitle: {
    margin: '15px 0',
    textAlign: 'center',
  },
  link: {
    margin: '10px 0',
    textAlign: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  dialogActions: {
    textAlign: 'center',
    marginTop: 15,
  },
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,.5)',
    zIndex: 1,
  },
  progress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

export const addressStyles = theme => ({
  dialogTitle: {
    margin: '15px 0',
    textAlign: 'center',
  },
  link: {
    margin: '10px 0',
    textAlign: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  dialogActions: {
    textAlign: 'center',
    marginTop: 15,
  },
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,.5)',
    zIndex: 1,
  },
  progress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

export const reviewStyles = theme => ({
  dialogTitle: {
    margin: '15px 0',
    textAlign: 'center',
  },
  list: {
    width: '100%',
  },
  dialogActions: {
    textAlign: 'center',
    marginTop: 15,
  },
  viewPrices: {
    marginTop: 25,
    textAlign: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
})

export const reservation = theme => ({
  dialogTitle: {
    margin: '15px 0',
    textAlign: 'center',
  },
  dialogActions: {
    textAlign: 'center',
    marginTop: 15,
  },
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,.5)',
    zIndex: 1,
  },
  progress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

export const delivery = theme => ({
  dialogTitle: {
    margin: '15px 0',
    textAlign: 'center',
  },
  dialogActions: {
    textAlign: 'center',
    marginTop: 15,
  },
  changeAddress: {
    marginBottom: 25,
    textAlign: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  dateListContainer: {
    width: '100%',
    marginBottom: 15,
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    overflowX: 'auto',
    overflowY: 'hidden',
    position: 'relative',
  },
  dateList: {
    flexWrap: 'nowrap',
    willChange: 'transform',
    overflowX: 'auto',
    width: '100%',
  },
  listTile: {
    cursor: 'pointer',
    width: '50px',
    textAlign: 'center',
  },
  dayOfWeek: {
    fontSize: '.75rem',
  },
  date: {
    height: 35,
    width: 35,
    padding: 5,
    fontSize: '1rem',
    margin: '0 auto',
  },
  dateSelected: {
    color: 'white',
    background: theme.palette.primary.main,
  },
  month: {
    fontSize: '1rem',
  },
  slotsContainer: {
    position: 'relative',
    minHeight: 32,
  },
  timeslotTile: {
    textAlign: 'center',
    cursor: 'pointer',
  },
  timeslotTileButton: {
    width: '100%',
  },
  viewPrices: {
    marginTop: 25,
    textAlign: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,.5)',
    zIndex: 1,
  },
  progress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

export const pickup = theme => ({
  dialogTitle: {
    margin: '15px 0',
    textAlign: 'center',
  },
  dialogActions: {
    textAlign: 'center',
    marginTop: 15,
  },
  changeAddress: {
    marginBottom: 25,
    textAlign: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  dateListContainer: {
    width: '100%',
    marginBottom: 15,
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    overflowX: 'auto',
    overflowY: 'hidden',
    position: 'relative',
  },
  dateList: {
    flexWrap: 'nowrap',
    willChange: 'transform',
    overflowX: 'auto',
    width: '100%',
  },
  listTile: {
    cursor: 'pointer',
    width: '50px',
    textAlign: 'center',
  },
  dayOfWeek: {
    fontSize: '.75rem',
  },
  date: {
    height: 35,
    width: 35,
    padding: 5,
    fontSize: '1rem',
    margin: '0 auto',
  },
  dateSelected: {
    color: 'white',
    background: theme.palette.primary.main,
  },
  month: {
    fontSize: '1rem',
  },
  slotsContainer: {
    position: 'relative',
    minHeight: 32,
  },
  timeslotTile: {
    textAlign: 'center',
    cursor: 'pointer',
  },
  timeslotTileButton: {
    width: '100%',
  },
  viewPrices: {
    marginTop: 25,
    textAlign: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,.5)',
    zIndex: 1,
  },
  progress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

const styles = theme => ({
  changeAddress: {
    marginBottom: 25,
    textAlign: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  dateListContainer: {
    width: '100%',
    marginBottom: 15,
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    overflowX: 'auto',
    overflowY: 'hidden',
    position: 'relative',
  },
  dateList: {
    flexWrap: 'nowrap',
    willChange: 'transform',
    overflowX: 'auto',
    width: '100%',
  },
  listTile: {
    cursor: 'pointer',
    width: '50px',
    textAlign: 'center',
  },
  dayOfWeek: {
    fontSize: '.75rem',
  },
  date: {
    height: 35,
    width: 35,
    padding: 5,
    fontSize: '1rem',
    margin: '0 auto',
  },
  dateSelected: {
    color: 'white',
    background: theme.palette.primary.main,
  },
  month: {
    fontSize: '1rem',
  },
  slotsContainer: {
    position: 'relative',
    minHeight: 32,
  },
  timeslotTile: {
    textAlign: 'center',
    cursor: 'pointer',
  },
  timeslotTileButton: {
    width: '100%',
  },
  viewPrices: {
    marginTop: 25,
    textAlign: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/rent/styles.js